<template>
  <template v-if="type === 'gold-coins-burst'">
    <div class="checkbox-view gold-coins-burst-checkbox">
      <label class="checkbox-container">
        <span class="checkbox-round">
          <input v-model="checked" class="checkbox-input" type="checkbox" @change="change" />
        </span>
        <span class="text">Não mostrar novamente hoje</span>
      </label>
    </div>
  </template>
  <template v-else>
    <div class="checkbox-view">
      <div class="checkbox-container">
        <input
          v-model="checked"
          class="checkbox"
          type="checkbox"
          :checked="localChecked === 'checked'"
          @change="change"
        />
        <span class="text">Não mostrar novamente hoje</span>
      </div>
    </div>
  </template>
</template>

<script setup>
const props = defineProps({
  type: {
    type: String,
    default: 'images',
  },
})

const localChecked = ref(window.localStorage.ImagesPopupChecked || 'null')
const localType = ref('')
const getLocalCheckedType = () => {
  switch (props.type) {
    case 'images':
      localChecked.value = window.localStorage.ImagesPopupChecked || 'null'
      localType.value = 'ImagesPopupChecked'
      break
    case 'atividade':
      localChecked.value = window.localStorage.AtividadePopupChecked || 'null'
      localType.value = 'AtividadePopupChecked'
      break
    case 'site-message':
      localChecked.value = window.localStorage.SiteMessagePopupChecked || 'null'
      localType.value = 'SiteMessagePopupChecked'
      break
    case 'gold-coins-burst':
      localChecked.value = window.localStorage.GoldCoinsBurstPopupChecked || 'null'
      localType.value = 'GoldCoinsBurstPopupChecked'
      break
    case 'seven-day-check-in':
      localChecked.value = window.localStorage.SevenDayCheckInPopupChecked || 'null'
      localType.value = 'SevenDayCheckInPopupChecked'
      break
    case 'security-certification':
      localChecked.value = window.localStorage.SecurityCertificationPopupChecked || 'null'
      localType.value = 'SecurityCertificationPopupChecked'
      break
    default:
      localChecked.value = window.localStorage.ImagesPopupChecked || 'null'
  }
}
getLocalCheckedType()

const checked = ref(localChecked.value === 'checked')
const change = () => {
  window.localStorage.setItem(localType.value, checked.value ? 'checked' : 'null')
  emit('change', checked.value)
}

const emit = defineEmits(['change'])
</script>

<style lang="less" scoped>
.checkbox-view {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;

  &.gold-coins-burst-checkbox {
    pointer-events: auto;

    .checkbox-container {
      padding: 0;
      background: transparent;
      cursor: pointer;

      .checkbox-round {
        position: relative;
        width: 18px;
        height: 18px;
        border: 1.5px solid #ffffff66;
        border-radius: 50%;
        background: transparent;
        flex-shrink: 0;
        box-sizing: border-box;
      }

      .checkbox-input {
        position: absolute;
        inset: 0;
        width: 100%;
        height: 100%;
        margin: 0;
        opacity: 0;
        cursor: pointer;
      }

      .checkbox-round:has(.checkbox-input:checked)::after {
        content: '';
        position: absolute;
        left: 50%;
        top: 45%;
        width: 4px;
        height: 8px;
        border: solid #ffffff;
        border-width: 0 2px 2px 0;
        transform: translate(-50%, -50%) rotate(45deg);
      }

      .text {
        color: #ffffff99;
      }
    }
  }

  .checkbox-container {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5px 10px;
    background: #00000061;
    border-radius: 5px;

    .checkbox {
      width: 20px;
    }

    .text {
      margin-left: 5px;
      font-size: 12px;
      color: #fff;
    }
  }
}
</style>
